import { PermissionNew } from "@/features/ACL/type";
import MyAxios from "@/utilize/MyAxios";
import { useQuery } from "@tanstack/react-query";

type TArgumants = {
  roleId: string;
};

export const useGetPermissionsRoles = ({ roleId }: TArgumants) => {
  return useQuery({
    queryFn: () =>
      MyAxios.get<{
        permissions: PermissionNew[];
      }>(`/acl/role-permissions`, { params: { name: roleId } }).then(
        (res) => res.data,
      ),
    queryKey: ["permissionsRoles", roleId],
  });
};
